<template>
  <div id="review-second-step" class="overflow-content">
    <v-row class="mt-3 text-left">
      <v-col cols="12">
        <v-btn
          icon
          depressed
          width="13"
          height="7"
          @click="$emit('go-back-action', 0)"
        >
          <v-icon size="13">{{left_arrow_btn}}</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12">
        <div class="title-4">
          Review your Order
        </div>
      </v-col>
    </v-row>

    <div>
      <v-btn
        icon
        width="60"
        height="4"
        :class="{'mr-2': index != reviewSteps.length - 1}"
        v-for="(item, index) in reviewSteps"
        :key="item.name"
      >
        <v-icon
          size="60"
          v-if="item.active"
        >
          {{review_bar_active}}
        </v-icon>
        <v-icon
          size="60"
          v-else
        >
          {{review_bar_inactive}}
        </v-icon>
      </v-btn>
    </div>

    <v-row class="mt-8">
      <v-col cols="12">
        <div class="title-5">
          {{reviewTitle}}
        </div>
        <div class="body-3 mt-2 text-center">
          Select all that apply
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-chip-group
          column
          multiple
          id="like-items-group"
        >
          <v-chip
            v-for="(item, index) in items"
            :key="'item-'+index"
            class="body-3 like-item"
            active-class="active-item"
          >
            {{ item.name }}
            <v-icon size="8" class="ml-4">{{plus_btn}}</v-icon>
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <div class="submit-btn-container">
      <v-btn
        block
        depressed
        class="title-12 confirm-btn"
        @click="$emit('continue', 2)"
      >
        Continue
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: 'ReviewSecondStep',
    computed: {
      ...mapGetters([
        "rating",
        "reviewTitles",
        "reviewSteps"
      ]),
      reviewTitle() {
        let result = 'What did you love?';
        let matchTitle = this.reviewTitles.filter((el) => {
          return el.rating === this.rating;
        });
        if (matchTitle.length != 0) {
          result = matchTitle[0].title;
        }
        return result;
      }
    },
    data: () => ({
      items: [
        {name: 'Extras', active: false},
        {name: 'Surprise Extras', active: false},
        {name: 'Extras', active: false},
        {name: 'Surprise Extras', active: false},
        {name: 'Extras', active: false},
        {name: 'Surprise Extras', active: false},
        {name: 'Extras', active: false},
        {name: 'Extras', active: false},
        {name: 'Extras', active: false}
      ],
      left_arrow_btn: "$vuetify.icons.left_arrow_btn",
      review_bar_active: "$vuetify.icons.review_bar_active",
      review_bar_inactive: "$vuetify.icons.review_bar_inactive",
      plus_btn: "$vuetify.icons.plus_btn"
    }),
    methods: {
      ...mapActions([
      ])
    }
  };
</script>

<style type="text/css">
  #review-second-step.overflow-content {
    padding: 0 20px 30px;
  }

  #like-items-group .v-slide-group__content {
    justify-content: center;
  }

  #like-items-group .like-item {
    background: #E0E0E0;
    border-radius: 16px;
    color: #001254;
    padding: 8px 12px;
  }

  #like-items-group .active-item {
    background: #001254;
  }

  #like-items-group .v-chip.active-item .v-chip__content {
    color: #5BE789;
  }

  #like-items-group .v-chip.active-item .v-chip__content svg path {
    fill: #5BE789;
  }
</style>